import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchOwnedAssetsAction } from '../store/reducer/ownedAssetDetails';
import { fetchPropertyDetailsAction } from '../store/reducer/propertyDetailSlice';

export const useOwnedAssetDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onFetchFail = () => {
    navigate(`/portfolio`);
  };
  async function fetchPropertyDetails(propertyId) {
    await dispatch(
      fetchPropertyDetailsAction({
        id: propertyId,
        onFail: onFetchFail,
      })
    );
  }
  async function fetchOwnedAssets(propertyId) {
    await dispatch(
      fetchOwnedAssetsAction({
        propertyId,
        onFail: onFetchFail,
      })
    );
  }

  return {
    fetchPropertyDetails,
    fetchOwnedAssets,
  };
};
